import { FileUpload as ArkFileUpload } from '@ark-ui/react';

import { cn } from '../../lib/utils';

function FileUploadRoot({ className, ...props }: ArkFileUpload.RootProps) {
	return <ArkFileUpload.Root className={cn('pt-file-upload', className)} {...props} />;
}

function FileUploadRootProvider(props: ArkFileUpload.RootProviderProps) {
	return <ArkFileUpload.RootProvider {...props} />;
}

function FileUploadLabel({ className, ...props }: ArkFileUpload.LabelProps) {
	return <ArkFileUpload.Label className={cn('pt-file-upload-label', className)} {...props} />;
}

function FileUploadTrigger({ className, ...props }: ArkFileUpload.TriggerProps) {
	return <ArkFileUpload.Trigger className={cn('pt-file-upload-trigger', className)} {...props} />;
}

function FileUploadDropzone({ className, ...props }: ArkFileUpload.DropzoneProps) {
	return <ArkFileUpload.Dropzone className={cn('pt-file-upload-dropzone', className)} {...props} />;
}

function FileUploadItemGroup({ className, ...props }: ArkFileUpload.ItemGroupProps) {
	return (
		<ArkFileUpload.ItemGroup className={cn('pt-file-upload-item-group', className)} {...props} />
	);
}

function FileUploadItem({ className, ...props }: ArkFileUpload.ItemProps) {
	return <ArkFileUpload.Item className={cn('pt-file-upload-item', className)} {...props} />;
}

function FileUploadItemPreview({ className, ...props }: ArkFileUpload.ItemPreviewProps) {
	return (
		<ArkFileUpload.ItemPreview
			className={cn('pt-file-upload-item-preview', className)}
			{...props}
		/>
	);
}

function FileUploadItemPreviewImage({ className, ...props }: ArkFileUpload.ItemPreviewImageProps) {
	return (
		<ArkFileUpload.ItemPreviewImage
			className={cn('pt-file-upload-item-preview-image', className)}
			{...props}
		/>
	);
}

function FileUploadItemName({ className, ...props }: ArkFileUpload.ItemNameProps) {
	return (
		<ArkFileUpload.ItemName className={cn('pt-file-upload-item-name', className)} {...props} />
	);
}

function FileUploadItemSizeText({ className, ...props }: ArkFileUpload.ItemSizeTextProps) {
	return (
		<ArkFileUpload.ItemSizeText className={cn('pt-file-upload-item-size', className)} {...props} />
	);
}

function FileUploadItemDeleteTrigger({
	className,
	...props
}: ArkFileUpload.ItemDeleteTriggerProps) {
	return (
		<ArkFileUpload.ItemDeleteTrigger
			className={cn('pt-file-upload-item-delete', className)}
			{...props}
		/>
	);
}

function FileUploadClearTrigger({ className, ...props }: ArkFileUpload.ClearTriggerProps) {
	return (
		<ArkFileUpload.ClearTrigger className={cn('pt-file-upload-clear', className)} {...props} />
	);
}

function FileUploadHiddenInput(props: ArkFileUpload.HiddenInputProps) {
	return <ArkFileUpload.HiddenInput {...props} />;
}

const FileUpload = {
	Root: FileUploadRoot,
	RootProvider: FileUploadRootProvider,
	Label: FileUploadLabel,
	Trigger: FileUploadTrigger,
	Dropzone: FileUploadDropzone,
	ItemGroup: FileUploadItemGroup,
	Item: FileUploadItem,
	ItemPreview: FileUploadItemPreview,
	ItemPreviewImage: FileUploadItemPreviewImage,
	ItemName: FileUploadItemName,
	ItemSizeText: FileUploadItemSizeText,
	ItemDeleteTrigger: FileUploadItemDeleteTrigger,
	ClearTrigger: FileUploadClearTrigger,
	HiddenInput: FileUploadHiddenInput,
	Context: ArkFileUpload.Context
};

export { FileUpload };
